import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RepService } from '../../services/rep.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html'
})
export class VerifyEmailComponent implements OnInit {
  /** True po dokončení verifikace (úspěšné i neúspěšné). Globální overlay řeší samotný load. */
  resultReady = false;
  isSuccess = false;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private repService: RepService
  ) { }

  ngOnInit(): void {
    // Nejprve zkontrolovat query parametry (přesměrování z BE)
    const status = this.route.snapshot.queryParamMap.get('status');
    const message = this.route.snapshot.queryParamMap.get('message');

    if (status) {
      // Přišli jsme z backend přesměrování
      if (status === 'success') {
        this.isSuccess = true;
      } else {
        this.isSuccess = false;
        this.errorMessage = message || 'Ověření se nezdařilo';
      }
      this.resultReady = true;
      return;
    }

    // Fallback: token v URL (pro zpětnou kompatibilitu)
    const token = this.route.snapshot.paramMap.get('token');
    if (token) {
      this.verifyEmail(token);
    } else {
      this.errorMessage = 'Chybí verifikační token';
      this.resultReady = true;
    }
  }

  async verifyEmail(token: string): Promise<void> {
    try {
      const result = await this.repService.verifyEmail(token);
      this.isSuccess = result?.success === true;
      if (!this.isSuccess) {
        this.errorMessage = result?.message || 'Ověření se nezdařilo';
      }
    } catch (error: any) {
      this.isSuccess = false;
      this.errorMessage = error?.error?.message || 'Ověření se nezdařilo';
    } finally {
      this.resultReady = true;
    }
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
